export const facetFacUrl = 'https://static.facetwealth.com/app/icons/brand/facet_fac_negative.svg';
